import { faTrash } from '@fortawesome/pro-light-svg-icons/faTrash'
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark'

import Button from '@hotmart/space-lib/dist/components/button'
import Icon from '@hotmart/space-lib/dist/components/icon'
import ModalBody from '@hotmart/space-lib/dist/components/modalBody'
import ModalFooter from '@hotmart/space-lib/dist/components/modalFooter'
import ModalHeader from '@hotmart/space-lib/dist/components/modalHeader'

import '@hotmart/cosmos/dist/styles/utilities/screenreaders.css'
import i18n from 'src/i18n'
import Modal from 'src/components/Modal'

import { PostLeaveModalProps } from './types'

const PostLeaveModal = ({
  isOpen,
  onClose,
  onKeepEditing,
  isEditPost = false
}: PostLeaveModalProps) => {
  return (
    <Modal show={isOpen} onClose={onClose}>
      <ModalHeader className="_px-5 _pt-5 _pb-4">
        <div className="_d-flex _align-items-baseline">
          <h2 className="_text-4 _m-0 _mr-4">
            {i18n.t(isEditPost ? 'edit_post.leave_modal.title' : 'modals.publish_post_leave.title')}
          </h2>

          <Button
            variation="tertiary"
            className="_p-0 _d-flex _border-0 _bg-transparent _text-gray-400 _ml-auto"
            onClick={onClose}
          >
            <span className="_sr-only">close</span>
            <Icon icon={faXmark} className="_w-5 _h-5" />
          </Button>
        </div>
      </ModalHeader>

      <ModalBody className="_p-0 _px-5">
        <p className="_text-2 _text-gray-500 _m-0">
          {i18n.t(
            isEditPost
              ? 'edit_post.leave_modal.description'
              : 'modals.publish_post_leave.description'
          )}
        </p>
      </ModalBody>

      <ModalFooter className="_px-5 _pt-8 _pb-5">
        <div className="_d-flex _ml-auto">
          <Button
            className="_bg-transparent _border-0 _mr-5"
            variation="default"
            onClick={onKeepEditing}
          >
            {i18n.t('modals.publish_post_leave.buttons.keep_editing')}
          </Button>

          <Button onClick={onClose}>
            <Icon icon={faTrash} className="_mr-2" />
            {i18n.t('modals.publish_post_leave.buttons.leave')}
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  )
}

export default PostLeaveModal
